const productUrl = 'https://znkp.ai.1andx.com'
const COZE_URL='https://api.coze.cn'
module.exports = {
    urls: process.env.NODE_ENV === 'development' ? '/BASE_URL' : productUrl,
	urls_coze:process.env.NODE_ENV === 'development' ?'/COZE_URL': COZE_URL
}
